/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ balance: NonNullable<unknown>, limit: NonNullable<unknown> }} Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs */

const en_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} of ${i?.limit} credits remaining`)
};

const de_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} von ${i?.limit} Credits verbleibend`)
};

const fr_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} crédits sur ${i?.limit} restants`)
};

const es_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} de ${i?.limit} créditos restantes`)
};

const it_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} crediti su ${i?.limit} rimanenti`)
};

const nl_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} van ${i?.limit} credits resterend`)
};

const pl_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozostało ${i?.balance} z ${i?.limit} kredytów`)
};

const fi_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance}/${i?.limit} krediittiä jäljellä`)
};

const da_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} af ${i?.limit} credits tilbage`)
};

const sv_keyword_optimizer_generate_cta_credits_remaining = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} av ${i?.limit} credits kvar`)
};

/**
* | output |
* | --- |
* | "{balance} of {limit} credits remaining" |
*
* @param {Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_credits_remaining = /** @type {((inputs: Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_Credits_RemainingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_credits_remaining(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_credits_remaining(inputs)
	return en_keyword_optimizer_generate_cta_credits_remaining(inputs)
});